import { render, staticRenderFns } from "./Loadpage.vue?vue&type=template&id=6480a36c"
import script from "./Loadpage.vue?vue&type=script&lang=js"
export * from "./Loadpage.vue?vue&type=script&lang=js"
import style0 from "./Loadpage.vue?vue&type=style&index=0&id=6480a36c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports